import { z } from 'zod'

export const updateUserFormSchema = z.object({
  lastName: z.string().min(1, { message: 'Поле не может быть пустым' }),
  firstName: z.string().min(1, { message: 'Поле не может быть пустым' }),
  middleName: z.string().default(''),
  email: z.string().optional(), // Email только для отображения, не валидируется
  companyType: z.string().min(1, { message: 'Поле не может быть пустым' }),
  companyId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  roles: z.array(z.string()).min(1, { message: 'Выберите хотя бы одну роль' }),
})

export type UpdateUserFormValues = z.infer<typeof updateUserFormSchema>
